import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CognitoService } from 'src/app/auth/services/cognito.service';

@Injectable({
  providedIn: 'root',
})
export class CBPayService {
  private baseUrl = environment.apiNest;

  constructor(
    private http: HttpClient,
    private cognitoService: CognitoService,
  ) {}

  // Método para obtener los headers con el token
  private async getHeaders(): Promise<HttpHeaders> {
    const session = await this.cognitoService.getSession();
    if (!session || !session.accessToken || !session.accessToken.jwtToken) {
      return new HttpHeaders().set('Content-Type', 'application/json');
    }

    const token = session.accessToken.jwtToken.trim();
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`);
    //console.log('Token', token)
    return headers;
  }

  async getTransactionsCBPay(
    page: number,
    limit: number,
    idNumberDestination?: string,
    from?: string,
    to?: string,
  ): Promise<any> {
    const headers = await this.getHeaders();
    const params: Record<string, string> = {
      page: `${page}`,
      limit: `${limit}`,
    };

    if (idNumberDestination)
      params['idNumberDestination'] = idNumberDestination;
    if (from) params['from'] = from;
    if (to) params['to'] = to;

    const serviceURL = `${this.baseUrl}transactions-cbpay?${new URLSearchParams(params).toString()}`;

    return firstValueFrom(this.http.get<any>(serviceURL, { headers }));
  }

  async downloadExcelCBPay(
    idNumberDestination?: string,
    from?: string,
    to?: string,
  ): Promise<void> {
    const headers = await this.getHeaders();

    const params: Record<string, string> = {};
    if (idNumberDestination)
      params['idNumberDestination'] = idNumberDestination;
    if (from) params['from'] = from;
    if (to) params['to'] = to;

    const url = `${this.baseUrl}transactions-cbpay/export/xls?${new URLSearchParams(params).toString()}`;

    const blob = await firstValueFrom(
      this.http.get(url, {
        headers,
        responseType: 'blob',
      }),
    );

    // Crear enlace de descarga
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = 'transacciones_cbpay.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(blobUrl);
  }

  // async validateTransferDirect(transactionId: number): Promise<any> {
  //   const headers = await this.getHeaders();
  //   const serviceURL = `${this.baseUrl}transactions-cbpay/validate-transfer-direct?transactionId=${transactionId}`;
  //   return firstValueFrom(this.http.get<any>(serviceURL, { headers }));
  // }
}
